import { connectRouter } from 'connected-react-router';
import { combineReducers } from 'redux';
import appHistory from './appHistory';
import authReducer from "../modules/Auth/authReducer.js";
import appReducer from "./appReducer.js";
import transactionsReducer from "../modules/Transactions/transactionsReducer";

const rootReducers = combineReducers({
    router: connectRouter(appHistory),
    app: appReducer,
    auth: authReducer,
    transactions: transactionsReducer,
});

export default rootReducers;
